import type { AxiosInstance } from 'axios'
import type { IAuthTokens, ILoginResponse, ITokenResponse } from '../classes'
import { FutManagerApi } from '../FutManagerApi'

const defaultAxios = () => FutManagerApi.axios.axiosInstance!

export default class LoginEndpoint {
  static login(
    login: string,
    password: string,
    captchaToken = '',
    axiosInstance: AxiosInstance = defaultAxios(),
  ) {
    return axiosInstance.post<ILoginResponse>('/login', {
      'g-recaptcha-response': captchaToken,
      login,
      password,
    })
  }

  /** Exchange a refresh token for a new access + refresh pair (access TTL ≈ 1h). */
  static refresh(
    refreshToken: string,
    axiosInstance: AxiosInstance = defaultAxios(),
  ) {
    return axiosInstance.post<IAuthTokens>('/login/refresh', {
      refresh_token: refreshToken,
    })
  }

  static token(axiosInstance: AxiosInstance = defaultAxios()) {
    return axiosInstance.get<ITokenResponse>('/login/token')
  }
}
